import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface SendOrderProps extends CacheProps {
  orderItemId: string
  discountCode: string
  gateway: string
  creditAllowed: boolean
  discountAllowed: boolean
}

const sendOrder = ({ orderItemId, discountCode, discountAllowed, creditAllowed, gateway, ...rest }: SendOrderProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.send.order'],
    payload: {
      order_id: orderItemId,
      discount_coupon_code: discountCode,
      use_credit_allowed: creditAllowed,
      use_discount_coupon_allowed: discountAllowed,
      gateway: gateway,
    },
    withToken: true,
    ...rest,
  });
};

export default sendOrder;
